import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=81d8d7fc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=81d8d7fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d8d7fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81d8d7fc')) {
      api.createRecord('81d8d7fc', component.options)
    } else {
      api.reload('81d8d7fc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=81d8d7fc&scoped=true&", function () {
      api.rerender('81d8d7fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eg3tNOmVeG0q/JS/comp/PopupBox.vue"
export default component.exports